export const iconFontAwesomePhotosImagesSliders = (
	<i className="fa-solid fa-sliders"></i>
);
